module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="touristGroup__children-text">\n    Укажите возраст ребёнка на момент поездки. Возраст влияет на параметры и цену предложения\n</div>';
}
return __p;
};
